/**
 * 时间转换工具函数
 */

/**
 * 将 UTC 时间字符串转换为东八区时间字符串
 * @param {string} utcTimeString - UTC 时间字符串
 * @param {boolean} includeTime - 是否包含时间部分
 * @returns {string} 东八区时间字符串
 */
export function formatUTCToBeijing(utcTimeString, includeTime = true) {
  if (!utcTimeString) return '-';

  try {
    const utcDate = new Date(utcTimeString);
    // 直接加8小时转换为东八区时间
    const beijingDate = new Date(utcDate.getTime() + 8 * 60 * 60 * 1000);

    if (includeTime) {
      return beijingDate.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    } else {
      return beijingDate.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  } catch (error) {
    console.error('时间转换失败:', error);
    return utcTimeString;
  }
}

